"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecipientType = void 0;
var RecipientType = /*#__PURE__*/function (RecipientType) {
  RecipientType["Participant"] = "participant";
  RecipientType["Contact"] = "contact";
  RecipientType["User"] = "user";
  return RecipientType;
}(RecipientType || (exports.RecipientType = RecipientType = {}));

